import { getNpsItemStatus } from './npsWorkflow';

/**
 * Parse resolution JSON from API: { versions: [ { body, at, by }, ... ] }
 */
export function parseNpsResolution(resolutionRaw) {
  if (resolutionRaw === undefined || resolutionRaw === null) {
    return { format: 'empty' };
  }

  const str = String(resolutionRaw).trim();
  if (!str) {
    return { format: 'empty' };
  }

  try {
    const parsed = JSON.parse(str);
    const versions = parsed?.versions;

    if (Array.isArray(versions) && versions.length > 0) {
      const latest = versions[versions.length - 1];
      const body = latest.body ?? null;
      const hasBody = body != null && String(body).trim() !== '';

      return {
        format: hasBody ? 'versioned' : 'empty_latest',
        body: hasBody ? String(body).trim() : null,
        at: latest.at ?? null,
        by: latest.by ?? null,
      };
    }
  } catch {
    return { format: 'empty' };
  }

  return { format: 'empty' };
}

/** What to show when status is resolved or closed. */
export function getNpsResolutionDisplay(item) {
  if (!item) return { mode: 'none' };

  const status = getNpsItemStatus(item);
  const closed = status === 'closed';
  const parsed = parseNpsResolution(item.resolution);

  if (parsed.format === 'versioned') {
    return {
      mode: 'note',
      body: parsed.body,
      at: parsed.at || (closed ? item.closed_at : item.resolved_at),
      by: parsed.by || (closed ? item.closed_by : item.resolved_by),
    };
  }

  return {
    mode: closed ? 'closed' : 'marked_complete',
    at: closed ? item.closed_at : item.resolved_at,
    by: closed ? item.closed_by : item.resolved_by,
  };
}

/** Latest resolution note body for editing (empty string if none shown). */
export function getNpsResolutionNoteBody(item) {
  const display = getNpsResolutionDisplay(item);
  if (display.mode === 'note' && display.body) {
    return display.body;
  }
  return '';
}
